module.exports = __webpack_public_path__ + "img/dowload_email_btn@2x.fe88485e.png";